import { useDaily } from '@daily-co/daily-react';
import { useEffect, useState } from 'react';

export const useParticipants = () => {
  const daily = useDaily();
  const [participants, setParticipants] = useState({});
  const [participantsCount, setParticipantsCount] = useState(0);

  useEffect(() => {
    if (!daily) return;

    const updateParticipants = () => {
      const allParticipants = daily.participants();
      setParticipants(allParticipants);
      setParticipantsCount(
        new Set(Object.values(allParticipants).map((p) => p.user_name)).size,
      );
    };

    updateParticipants(); // Initial fetch

    daily.on('participant-joined', updateParticipants);
    daily.on('participant-updated', updateParticipants);
    daily.on('participant-left', updateParticipants);

    return () => {
      daily.off('participant-joined', updateParticipants);
      daily.off('participant-updated', updateParticipants);
      daily.off('participant-left', updateParticipants);
    };
  }, [daily]);

  return {
    participants,
    participantsCount,
  };
};
